export default "__VITE_ASSET__BMdPO43v__"